import { DeviationStatus } from 'src/enums'
import { IDeviationPriority } from 'src/generated-types/deviation-priority'
import { MUIThemeColors } from 'src/mui-theme'

/**
 * Single source of truth for deviation status / priority colors.
 *
 * `deviationStatus` is the `DeviationStatus` enum (Open / InApproval / Complete).
 * `priority` is the `IDeviationPriority` enum (Normal / Critical).
 */

export const statusColorToken = (deviationStatus?: DeviationStatus | number): MUIThemeColors => {
  switch (deviationStatus) {
    case DeviationStatus.Open:
      return MUIThemeColors.primaryMain
    case DeviationStatus.InApproval:
      return MUIThemeColors.warningMain
    case DeviationStatus.Complete:
      return MUIThemeColors.successMain
    default:
      return MUIThemeColors.primaryMain
  }
}

export const priorityColorToken = (priority?: IDeviationPriority | number): MUIThemeColors => {
  return priority === IDeviationPriority.Critical ? MUIThemeColors.errorMain : MUIThemeColors.secondaryMain
}
